export const truckCodesRoot = '/truck-codes'

export const truckCodesRoute = {
  list: '/',
  create: '/create',
  view: '/:id',
}
